import React from "react";
import styled from "styled-components";
import { CautionIcon, CloseIcon } from "../../../../components/svgs";
import { Button, StyledText } from "../../../../components/common";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CautionIcon fill="white" stroke="#333" width="90" height="90" />
        <StyledText style={{ fontSize: 20, textAlign: "center" }}>
          {title}
        </StyledText>
        <StyledText
          style={{ fontSize: 16, textAlign: "center" }}
          color="#7F7F7F"
        >
          {message}
        </StyledText>
        <ButtonGroup>
          <Button
            style={{ border: "2px solid #333", width: "100%" }}
            onClick={onClose}
          >
            <StyledText color="#333">Cancel</StyledText>
          </Button>
          <Button
            style={{ backgroundColor: "#b22525", width: "100%" }}
            onClick={onConfirm}
          >
            <StyledText color="white">{confirmText}</StyledText>
          </Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ConfirmModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  width: 80%;
  max-width: 400px;
  text-align: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;
`;
